import { fmtDate } from "@/lib/api";

const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
const lineLabel = (it) => `${it.name} ${it.vial_size || ""}`.trim();
const vendorLine = (po) => [po.vendor_contact, po.vendor_phone, po.vendor_email].filter(Boolean).join(" · ");

export function poText(po) {
  const lines = po.items.map((it) => `- ${lineLabel(it)}: ${it.boxes} box${it.boxes > 1 ? "es" : ""} (${it.boxes * it.box_size} vials)`);
  return [
    `Order ${po.po_number} from Korevex Bio`,
    `Date: ${fmtDate(po.created_at)}`,
    `To: ${po.vendor_name}`,
    "",
    ...lines,
    "",
    `Total: ${po.items.reduce((s, it) => s + it.boxes, 0)} boxes`,
    ...(po.notes ? ["", `Notes: ${po.notes}`] : []),
  ].join("\n");
}

export function printPoSheet(po) {
  const rows = po.items.map((it) => `<tr><td>${esc(it.name)}</td><td>${esc(it.vial_size)}</td><td class="n">${it.boxes}</td><td class="n">${it.box_size}</td><td class="n">${it.boxes * it.box_size}</td></tr>`).join("");
  const total = po.items.reduce((s, it) => s + it.boxes, 0);
  const html = `<!doctype html><html><head><title>${esc(po.po_number)}</title><style>
    body{font-family:Arial,sans-serif;color:#0f172a;margin:40px}h1{margin:0;font-size:26px}.muted{color:#64748b;font-size:13px}
    .head{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:2px solid #0f172a;padding-bottom:16px;margin-bottom:24px}
    table{width:100%;border-collapse:collapse;margin-top:16px}th,td{border-bottom:1px solid #cbd5e1;padding:10px 8px;text-align:left;font-size:14px}
    th{font-size:11px;letter-spacing:1px;text-transform:uppercase;color:#475569}.n{text-align:right}tfoot td{font-weight:bold;border-bottom:none}
    .notes{margin-top:24px;padding:12px;border:1px solid #cbd5e1;border-radius:6px;font-size:14px;white-space:pre-wrap}
  </style></head><body>
    <div class="head"><div><p class="muted" style="margin:0 0 4px;letter-spacing:2px">KOREVEX BIO</p><h1>Order sheet</h1></div>
    <div style="text-align:right"><strong>${esc(po.po_number)}</strong><br/><span class="muted">${esc(fmtDate(po.created_at))}</span></div></div>
    <p style="margin:0"><span class="muted">To</span><br/><strong>${esc(po.vendor_name)}</strong><br/><span class="muted">${esc(vendorLine(po))}</span></p>
    <table><thead><tr><th>Product</th><th>Content</th><th class="n">Boxes</th><th class="n">Vials / box</th><th class="n">Total vials</th></tr></thead>
    <tbody>${rows}</tbody><tfoot><tr><td colspan="2">Total</td><td class="n">${total}</td><td></td><td class="n">${po.items.reduce((s, it) => s + it.boxes * it.box_size, 0)}</td></tr></tfoot></table>
    ${po.notes ? `<div class="notes"><strong>Notes</strong><br/>${esc(po.notes)}</div>` : ""}
    <script>window.onload=function(){window.print()}</script>
  </body></html>`;
  const w = window.open("", "_blank");
  if (!w) return false;
  w.document.write(html);
  w.document.close();
  return true;
}
